export const STATES_CODES = [
    
      "Andhra Pradesh",
    
      "Andaman and Nicobar Islands",
    
      "Arunachal Pradesh",
    
      "Assam",
    
      "Bihar",
    
      "Chandigarh",
    
      "Chhattisgarh",
    
      "Dadra and Nagar Haveli",
    
      "Daman and Diu",
    
      "Delhi",
    
      "Goa",
    
      "Gujarat",
    
      "Haryana",
    
      "Himachal Pradesh",
    
      "Jammu and Kashmir",
    
      "Jharkhand",
    
      "Karnataka",
    
      "Kerala",
    
      "Lakshadweep Islands",
    
      "Madhya Pradesh",
    
      "Maharashtra",
    
      "Manipur",
    
      "Meghalaya",
    
      "Mizoram",
    
      "Nagaland",
    
      "Odisha",
    
      "Pondicherry",
    
      "Punjab",
    
      "Rajasthan",
    
      "Sikkim",
    
      "Tamil Nadu",
    
      "Telangana",
    
      "Tripura",
    
      "Uttarakhand",
    
      "Uttar Pradesh",
    
      "West Bengal",
  ];